import grapesImg from "@/assets/products/grapes.jpg";
import onionImg from "@/assets/products/onion.jpg";
import pomegranateImg from "@/assets/products/pomegranate.jpg";
import orangeImg from "@/assets/products/orange.webp";
import mangoImg from "@/assets/products/mango.jpg";
import greenChilliImg from "@/assets/products/green-chilli.webp";
import garlicImg from "@/assets/products/garlic.jpg";
import raisinsImg from "@/assets/products/raisins.webp";
import turmericImg from "@/assets/products/turmeric.jpg";
import chickpeasImg from "@/assets/products/chickpeas.jpg";

export const MAIN_PRODUCTS = [
  { name: "Grapes", image: grapesImg, testId: "product-grapes" },
  { name: "Fresh Red Onion", image: onionImg, testId: "product-fresh-red-onion" },
  { name: "Pomegranate", image: pomegranateImg, testId: "product-pomegranate" },
  { name: "Orange", image: orangeImg, testId: "product-orange" },
  { name: "Mango", image: mangoImg, testId: "product-mango" },
  { name: "Green Chilli", image: greenChilliImg, testId: "product-green-chilli" },
  { name: "Garlic", image: garlicImg, testId: "product-garlic" },
  { name: "Raisins", image: raisinsImg, testId: "product-raisins" },
  { name: "Turmeric", image: turmericImg, testId: "product-turmeric" },
  { name: "Chickpeas / Pulses", image: chickpeasImg, testId: "product-chickpeas-pulses" },
];
